export default __webpack_public_path__ + "media/images/react_icons/dolar-sign-rounded-grey-5d02c878120bed1e5025d8e93b040fd1.svg";